import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { BrandStatement } from "@/components/BrandStatement";
import { Coverage } from "@/components/Coverage";
import { Gallery } from "@/components/Gallery";
import { Process } from "@/components/Process";
import { Testimonials } from "@/components/Testimonials";
import { Referral } from "@/components/Referral";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-ink text-slate-100">
      <div className="grain-overlay" />
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BrandStatement />
        <Coverage />
        <Gallery />
        <Process />
        <Testimonials />
        <Referral />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
